module.exports = __webpack_public_path__ + "font_banana_son.54ed70ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_banana_son.png
// module id = +s8M
// module chunks = 0